import { render, staticRenderFns } from "./PersonalInputs.vue?vue&type=template&id=17131278&"
import script from "./PersonalInputs.vue?vue&type=script&lang=js&"
export * from "./PersonalInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports